import styled from 'styled-components';
import FleetFilters from './component';

export default styled(FleetFilters)`
  padding: 8px;
  display: flex;
  background-color: var(--primary-filters);

  .filter {
    margin-right: 8px;
  }
`;
